import { Directive, HostListener, ElementRef, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { CurrencyPipe } from '@angular/common';

@Directive({
  selector: '[appCurrencyFormat]'
})
export class CurrencyFormatDirective {

 constructor(
    private el: ElementRef<HTMLInputElement>,
    private control: NgControl
  ) {}

  // Bloquear letras
  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    const allowedKeys = [
      'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
      'ArrowLeft', 'ArrowRight', 'Home', 'End'
    ];

    if (
      allowedKeys.includes(event.key) ||
      (event.ctrlKey || event.metaKey)
    ) {
      return;
    }

    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  }

  // Formatear mientras escribe
  @HostListener('keyup')
  onKeyup() {
      const input = this.el.nativeElement;
      console.log('Directive funcionando');
    // solo números
    const raw = input.value.replace(/\D/g, '');

    if (!raw) {
      input.value = '';
      this.control.control?.setValue('', { emitEvent: false });
      return;
    }

    // últimos 2 decimales
    const value = Number(raw) / 100;

    const formatted = value.toLocaleString('es-AR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    const finalValue = `$ ${formatted}`;

    input.value = finalValue;
    this.control.control?.setValue(finalValue, { emitEvent: false });
  }

}